<template>
    <div id="current-search" class="single" v-if="show">
        <img class="btn close" src="@/assets/Images/Close.png" alt="Close" title="Close" width="20" height="20" @click="$emit('clear')"/>
        <span><b>FILTERS</b></span>
        <p class="filter-group" v-for="(filter, f) of currentSearch" :key="f"><b>{{ f }}:</b> {{ FilterList(filter) }}</p>
    </div>
</template>

<script>
export default {
    name: "TimelineCurrentSearch",
    props: {
        show: Boolean,
        currentSearch: Object
    },
    methods: {
        FilterList: function(filtered) {
            let filters, f;
            filters = "";
            f = 0;
            for (const filter of filtered) {
                f++;
                const delimiter = f < filtered.length ? ", " : "";
                filters += `${filter}${delimiter}`;
            }
            return filters;
        }
    },
    emits: [ "clear" ]
};
</script>